import { useQuery } from '@tanstack/react-query';
import { loadWorkbook } from '../content/workbook';
import { queryKeys } from '../query/keys';
import { useConfig, useSession } from './provider';

/**
 * Goodwin's workbook from Core, cached for the day. Undefined data until the environment
 * has the Stronger Memory types provisioned (`strongerMemoryTypes` in the env config).
 */
export function useWorkbook() {
  const session = useSession();
  const { strongerMemoryTypes: types } = useConfig();
  return useQuery({
    queryKey: queryKeys.workbook(),
    enabled: session.status === 'authenticated' && types !== undefined,
    staleTime: 24 * 60 * 60_000,
    queryFn: () => loadWorkbook(types as NonNullable<typeof types>),
  });
}
